import resourcesRepository from '@/repositories/resources.repository';
import { useQuery } from '@tanstack/react-query';

export function useGetResources(route: string) {
  return useQuery({
    queryKey: ['resources', 'get', route],
    queryFn: () => resourcesRepository.getResources(route),
  });
}
